export default __webpack_public_path__ + "static/media/x.85f9f2a1.svg";